
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContratosTable } from "./ContratosTable";
import { NovoContratoDialog } from "./NovoContratoDialog";
import { ContratoTemplateDialog } from "./ContratoTemplateDialog";
import { useContratos } from "@/hooks/useContratos";

export function Contratos() {
  const { data: contratos } = useContratos();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Contratos</h2>
          <p className="text-gray-600">Gerencie contratos de proteção dos seus clientes</p>
        </div>
        <div className="flex gap-2">
          <ContratoTemplateDialog />
          <NovoContratoDialog />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <ContratosTable />
      </div>
    </div>
  );
}
